const get = require('lodash/get')
const isWarehouseMatch = require('./is-warehouse-match')

module.exports = getShipmentConfirmEligibility

// Plain data in, plain facts out — no role/permission branching, no api
// calls. This computes the shipment-shape/location facts that confirm/pack
// eligibility depends on; the caller is responsible for combining these
// with whatever permission check applies to it (e.g. web's userIsAuthorised).
// Same convention as is-warehouse-match.js, which this wraps.
function getShipmentConfirmEligibility ({ shipment, destinationLocation, userLocation }) {
  const isImmediatePurchaseNew = get(shipment, 'planningType') === 'immediate_purchase' && get(shipment, 'status') === 'new'

  const isLastMileDelivery = !destinationLocation || destinationLocation.level === 'sdp'
  const isOwnWarehouse = isWarehouseMatch(get(userLocation, 'id'), get(shipment, 'destination.id'))

  return {
    isImmediatePurchaseNew,
    isLastMileDelivery,
    isOwnWarehouse
  }
}
